import { i18n } from "@/libs/i18n/i18n-config";

export const SHOP_URL = "/shop";
export const BLOG_URL = "/blog";
export const LOYALTY_BLOG_URL = "/loyalty-blog";
export const DEFAULT_LOCALE_CONFIG = {
  defaultLocale: i18n.defaultLocale,
  locales: i18n.locales,
};
